import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from '@/types';
import {
  OnboardingPayload,
  OnboardStepResponse,
  RegisterEmailPayload,
  VerifyEmailResponse,
} from '../types';
import { mapObjectKeysToSnakeCase } from '@/utils/mapper';
import { url } from 'inspector';

export const onboardAPI = createApi({
  reducerPath: 'onboardAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_BACKEND_URL,
  }),
  endpoints: (builder) => ({
    postLeadData: builder.mutation<
      ApiResponse<OnboardStepResponse>,
      (OnboardingPayload | RegisterEmailPayload) & {
        application_secret?: string;
      }
    >({
      query: ({ application_id, application_secret, data, step }) => {
        const transformedData = mapObjectKeysToSnakeCase(data);
        return {
          url: 'api/lead/v1/step/',
          method: 'POST',
          body: {
            application_id,
            application_secret,
            data: transformedData,
            step,
          },
        };
      },
    }),
    verifyEmail: builder.query<
      ApiResponse<VerifyEmailResponse>,
      { token: string }
    >({
      query: ({ token }) => `api/lead/v1/verify-email/${token}/`,
    }),
    onboardVerifyOTP: builder.mutation<
      ApiResponse<{
        verification_status: string;
        uid?: string;
        password_reset_token?: string;
      }>,
      { code: string; application_id: string }
    >({
      query: (body) => {
        return {
          url: 'api/lead/v1/verify-otp/',
          method: 'POST',
          body,
        };
      },
    }),
    resendLeadVerifyEmail: builder.mutation<
      ApiResponse<{ message: string }>,
      { id: string }
    >({
      query: ({ id }) => {
        return {
          url: `api/lead/v1/resend-verify-email/${id}/`,
          method: 'POST',
        };
      },
    }),
    resendOTP: builder.mutation<
      ApiResponse<{ message: string }>,
      { id: string }
    >({
      query: ({ id }) => {
        return {
          url: `api/lead/v1/resend-otp/${id}/`,
          method: 'POST',
        };
      },
    }),
  }),
});

export const {
  useVerifyEmailQuery,
  usePostLeadDataMutation,
  useResendLeadVerifyEmailMutation,
  useOnboardVerifyOTPMutation,
  useResendOTPMutation,
} = onboardAPI;
